import React from "react";

interface BackgroundLogoProps {
  src: string;
  alt?: string;
  opacity?: number;
  maxWidth?: string; // e.g., "20vw"
  minWidth?: string; // e.g., "150px"
}

const BackgroundLogo: React.FC<BackgroundLogoProps> = ({
  src,
  alt,
  opacity = 0.3,
  maxWidth = "20vw",
  minWidth = "150px",
}) => {
  return (
    <div
      className="fixed inset-0 flex justify-center items-center pointer-events-none z-0"
      style={{ opacity }}
    >
      <img
        src={src}
        alt={alt}
        style={{ maxWidth, minWidth, height: "auto", objectFit: "contain" }}
      />
    </div>
  );
};

export default BackgroundLogo;
